var _circle, _path, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426.5,
    cy: 444.5,
    r: 62.5,
    fill: "#17C7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.212 279.119C382.411 341.362 412.574 412.994 475.582 439.112C538.589 465.229 610.585 435.945 636.386 373.702C662.187 311.459 632.023 239.827 569.016 213.709C506.008 187.592 434.013 216.876 408.212 279.119Z",
    fill: "url(#loaderGradient16)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.728,
    cy: 311.946,
    rx: 164.5,
    ry: 166,
    transform: "rotate(-9.95835 341.728 311.946)",
    fill: "#ED801B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient16",
    x1: 512.781,
    y1: 286.388,
    x2: 548.694,
    y2: 447.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.0b95538a70a2c80e54f5d4ec89546d6593a0d7c49e021252b8532ffd0e602f0d.svg";
export { ForwardRef as ReactComponent };